export default __webpack_public_path__ + "static/media/gm.570f94c4.jpg";